<template>
    <div>
        <item-write-link v-for="component in optionLayouts" :key="`memberComp${component}`" :writeLayout="component" :itemData="itemData" :setData="setData"></item-write-link>
    </div>
</template>

<script>
    import VuxAlert from '@/mixins/vux-alert';
    import itemUtil from "@/components/item/itemUtil";
    import ItemWriteLink from "@/components/item/ItemWriteLink";
    import ItemValidator from "@/mixins/validators/ItemValidator";
    import EventBus from "@/utils/event-bus";
    import util from "@/mixins/util";

    export default {
        name: 'ItemWriteComponent',
        components: {
            ItemWriteLink
        },
        mixins: [ VuxAlert, itemUtil, ItemValidator ],
        props: {
            itemType: {
                type: String,
                default: '',
            },
            itemKey: {
                default: null,
            },
        },
        data() {
            return{
                optionLayouts: [],
                parsingData: {},
                createApiParamSet: {},
                detailApiParamSet: {},
                subFunc: '',
                directUrl: '',
                resultAlertTxt: '',

                itemData: {},
            }
        },
        mounted() {
        },
        watch: {

        },
        created() {
            this.initConfig();
            EventBus.$on('writeItem', this.writeItem);
        },
        beforeDestroy() {
            EventBus.$off('writeItem');
        },
        methods: {
            initConfig() {
                let itemConfig = this.returnItemConfig(this.itemType)
                this.createApiParamSet = itemConfig.createApiParamSet;
                this.detailApiParamSet = itemConfig.detailApiParamSet;
                this.subFunc = itemConfig.subFunc;
                this.directUrl = itemConfig.directUrl;
                this.resultAlertTxt = itemConfig.resultAlertTxt;
                this.parsingData = itemConfig.parsingData;
                if(this.itemKey != null) {
                    this.getInfo();
                }else{
                    this.initTemplate();
                }
            },
            initTemplate() {
                let itemConfig = this.returnItemConfig(this.itemType)
                this.optionLayouts = itemConfig.optionLayouts;
            },
            setData(key, value) {
                this[key] = value;
            },
            getInfo() {
                let params = JSON.parse(JSON.stringify(this.detailApiParamSet));
                params.id = this.itemKey;
                this.no = this.itemKey;
                try {
                    this.$api.$item.getItem(params).then(res => res.Data.Result).then(res => {
                        if(res.Info.type != 1) {
                            this.createAlert({
                                title: '알림',
                                content: '상품정보를 불러올 수 없습니다.',
                                btnText: '확인',
                                hide: () => {
                                    this.$router.back();
                                }
                            })
                        }
                        let info = res.List[0];
                        this.name = info.i_name;
                        this.country = info.c_idx;
                        this.price = info.i_price;
                        this.priceOrg = info.i_price_org
                        this.cycleDay = info.if_cycle_day;
                        this.itemData = {
                            no: this.no,
                            name: this.name,
                            country: this.country,
                            price: this.price,
                            priceOrg: this.priceOrg,
                            cycleDay: this.cycleDay,
                        }
                        this.initTemplate();
                    });
                }catch (e) {
                    console.log(e);
                }
            },
            writeItem() {
                let dataKeys = Object.keys(this.parsingData);
                this.$validate(dataKeys).then((success) => {
                    if(!success) {
                        this.errorAlert('모두 입력해주세요.');
                        return false;
                    }
                    let params = JSON.parse(JSON.stringify(this.createApiParamSet));
                    dataKeys.forEach(dataKey => {
                        params[this.parsingData[dataKey]] = this[dataKey];
                    });
                    try {
                        this.$api.$item[this.subFunc](params).then(res => res.Data.Result).then(res => {
                            if(res.Info.type != 1) {
                                this.errorAlert(type);
                                return false;
                            }
                            this.createAlert({
                                title: '확인',
                                content: this.resultAlertTxt,
                                btnText: '확인',
                                hide: () => {
                                    if(this.directUrl === '') {
                                        return false;
                                    }
                                    if(this.directUrl === 'back') {
                                        this.$router.back();
                                        return false;
                                    }
                                    let url = this.directUrl;
                                    this.$router.push(url);
                                }
                            })
                        })
                    }catch (e) {
                        console.log(e);
                    }
                })
            },
        }
    }
</script>
